import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import ErrorBoundary from '@components/errorboundary/ErrorBoundary';
import ChatUserDataDeletion from '@pages/chat/ChatUsertDataDeletion';
import GamesUserDataDeletion from '@pages/games/GamesUserDataDeletion';

function App() {
  const location = useLocation();
  const isChatPath = location.pathname.startsWith('/chat');
  return (
    <>
      <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Navigate to="/life/deletion" />} />
          <Route path="/life/deletion" element={<ChatUserDataDeletion />} />
          <Route path="/games/deletion" element={<GamesUserDataDeletion />} />
          <Route path="*" element={<Navigate to={isChatPath ? '/life/deletion' : '/games/deletion'} replace />} />
        </Routes>
      </ErrorBoundary>
    </>
  );
}

export default App;
